import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { Heading, Flex, Box, Container,Text } from '@magicsoup.io/stock'
import { ScrollToElement } from '../index'
import Addon from '../../images/assets/spaceship-btn.svg'

import {
  MissionButton,
  P,
  Mission,
  Section,
  Img,
} from '../../styled'

const Missions = () => (
  <StaticQuery
    query={graphql`
      query missionQuery {
        generalJson {
          missionButton
        }
      }
    `}
    render={staticData => (
      <Query query={MissionQuery}>
        {({
          loading, error, data
        }) => {
          if (loading) return "loading"
          if (error) return error.message

          return (
          <Section py={[3]}>
            <Container>
              { data.featuredMissions.map(( mission, index ) => 
              <Mission key={index} py={[3]}>
                <Flex alignItems="center" py={[1]} mx="auto" flexWrap="wrap">
                  <Box width={[1, 1/2, 1/2]}>
                    <Img src={mission.imageUrl} />
                  </Box>
                  <Flex width={[1, 1/2, 1/2]} flexDirection="column" alignItems="flex-start" px={[3,5,5]} py={[2]}>
                    <Heading as="h1" m="0" fontSize={[1,4,4]} py={[2]}>{mission.name}</Heading>
                    <P py={[4]} m={[0]}>{mission.description}</P>
                    <ScrollToElement
                      target="appStoreCTA"
                      Parent={MissionButton}
                      key={index}
                      tracking={mission}
                      >
                        <MissionButton.Addon src={Addon} />
                        <MissionButton.Label>{staticData.generalJson.missionButton}</MissionButton.Label>
                    </ScrollToElement>
                  </Flex>
                </Flex>
              </Mission>
            )}
            </Container>
          </Section>
          )
        }}
      </Query>
    )}
  />
)   

const MissionQuery = gql`
    {
      featuredMissions {
      id
      name
      description
      imageUrl
    }
  }
`

export default Missions





// query={graphql`
//           query {
//             missionsJson {
//               elements { 
//                 headline
//                 story
//                 MissionbuttonText
//                 missionColor
//                 image
//               }
//             }
//             missionImage: file(relativePath: { eq: "missions/mission.png" }) {
//               childImageSharp {
//                 fluid(maxWidth: 500, maxHeight: 380) {
//                   ...GatsbyImageSharpFluid
//                 }
//               }
//             }
//           }
//         `}